import { http } from "../http/Http";
import { Workflow } from "../models/Workflow";
import { ServiceResponse } from "../models/ServiceResponse";
import { GetByFiltersArguments } from "../models/GetByFiltersArguments";
import { StartWorkflow } from "../models/StartWorkflow";

export class WorkflowService {

    getWorkflowsByFilters = async (apiQueryFilter: GetByFiltersArguments): Promise<ServiceResponse<Workflow[]>> => {
        const { data } = await http.post<ServiceResponse<Workflow[]>>("WorkflowProcess/GetByFilters", apiQueryFilter);
        return data;
    };

    getWorkflow = async (id: number): Promise<Workflow> => {
        const { data } = await http.get<Workflow>(("WorkflowProcess/GetById/" + id.toString()));
        return data;
    };

    addWorkflow = async (workflow: Workflow): Promise<Workflow> => {
        const { data } = await http.post<Workflow>("WorkflowProcess/Post", workflow);
        return data;
    };

    updateWorkflow = async (workflow: Workflow): Promise<Workflow> => {
        const { data } = await http.put<Workflow>("WorkflowProcess/Put", workflow);
        return data;
    };

    deployWorkflow = async (id: Number): Promise<ServiceResponse<Boolean>> => {
        const { data } = await http.post<ServiceResponse<Boolean>>("WorkflowProcess/DeployProcess/" + id.toString());
        return data;
    };

    startWorkflow = async (startWorkflow: StartWorkflow): Promise<Boolean> => {
        const { data } = await http.post<Boolean>("WorkflowProcess/StartProcess", startWorkflow);
        return data;
    };

}